import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Periods from './Periods/Periods'
import { ProjectionTrackingScreen } from 'modules/core/components'

const Home = () => (
  <Switch>
    <Route exact path="/periodos" component={Periods} />
    <Route exact path="/periodos/actividad" component={ProjectionTrackingScreen} />
    <Redirect to="/periodos" />
  </Switch>
)

export default Home
